import { MenuAppAuto } from "../../../assets/svgs-index";
import { Category } from "../../models/category.model";
import { Option } from "../../models/components.model";

const categories: Category[] = [
  { id: 1, name: "Automóvel", icon: MenuAppAuto, key: MenuAppAuto },
  { id: 2, name: "Alojamento", icon: MenuAppAuto, key: MenuAppAuto },
  { id: 3, name: "Barcos", icon: MenuAppAuto, key: MenuAppAuto },
  { id: 4, name: "Bricolagem", icon: MenuAppAuto, key: MenuAppAuto },
  { id: 5, name: "Mundo Animal", icon: MenuAppAuto, key: MenuAppAuto },
  { id: 6, name: "Saúde", icon: MenuAppAuto, key: MenuAppAuto },
  { id: 8, name: "Informática", icon: MenuAppAuto, key: MenuAppAuto },
  { id: 9, name: "Pesca", icon: MenuAppAuto, key: MenuAppAuto },
  { id: 10, name: "Caça", icon: MenuAppAuto, key: MenuAppAuto },
  { id: 11, name: "Padel", icon: MenuAppAuto, key: MenuAppAuto },
  { id: 12, name: "Automóvel", icon: MenuAppAuto, key: MenuAppAuto },
  { id: 22, name: "Alojamento", icon: MenuAppAuto, key: MenuAppAuto },
  { id: 32, name: "Barcos", icon: MenuAppAuto, key: MenuAppAuto },
  { id: 42, name: "Bricolagem", icon: MenuAppAuto, key: MenuAppAuto },
  { id: 52, name: "Mundo Animal", icon: MenuAppAuto, key: MenuAppAuto },
  { id: 62, name: "Saúde", icon: MenuAppAuto, key: MenuAppAuto },
  { id: 82, name: "Informática", icon: MenuAppAuto, key: MenuAppAuto },
  { id: 92, name: "Pesca", icon: MenuAppAuto, key: MenuAppAuto },
  { id: 102, name: "Caça", icon: MenuAppAuto, key: MenuAppAuto },
  { id: 112, name: "Padel", icon: MenuAppAuto, key: MenuAppAuto },
];

const companyOptions: Option[] = [
  { value: 'ocean', label: 'Ocean', },
  { value: 'blue', label: 'Blue', },
  { value: 'purple', label: 'Purple',  },
  { value: 'red', label: 'Red',},
  { value: 'orange', label: 'Orange', },
  { value: 'yellow', label: 'Yellow',  },
  { value: 'green', label: 'Green',},
  { value: 'forest', label: 'Forest',  },
  { value: 'slate', label: 'Slate', },
  { value: 'silver', label: 'Silver' },
];

// Function to retrieve mock categories
export function getMockCategories(): Category[] {
  return categories;
}

// Function to retrieve mock companies
export function getMockCompanyOptions(): Option[] {
  return companyOptions;
}